var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"people"},[_vm._v("\n  "+_vm._s(_vm.$t('hearttoheart2'))+"\n  "),_c('br'),_vm._v("\n  "+_vm._s(_vm.$t('withPeople2'))+"\n  "),_c('br'),_vm._v("\n  "+_vm._s(_vm.$t('showyourtalent2'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }